import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class CustomerContactReferenceService extends BaseReferenceService {
  constructor() {
    super('CustomerContactReference');
  }
  getForCustomer(customerId: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/Customer/${customerId}`);
  }
}
